import FramesService from 'src/services/FramesService';
import { Dispatch, SetStateAction } from 'react';
import { FramesRecord, FramesSearchType } from 'src/models/Frames';

/**
 * Formats a FRAMES record for display
 * @param record The FRAMES record to format
 * @returns Formatted string combining account number and description
 */
export const formatFramesRecord = (record: FramesRecord): string =>
  `${record.accountNumber} - ${record.accountDescription}`;

/**
 * Function to fetch accounts from the service and store them in React context.
 *
 * @param framesService
 * @param setAccounts
 * @param setLoadingAccounts
 * @param setFetchAccountsErrorMessage
 * @param accountNum
 * @param searchType Type of search (EXACT or PREFIX)
 */
export const fetchAccounts = async (
  framesService: FramesService,
  setAccounts: Dispatch<SetStateAction<string[]>>,
  setLoadingAccounts: Dispatch<SetStateAction<boolean>>,
  setFetchAccountsErrorMessage: Dispatch<SetStateAction<string>>,
  accountNum: string,
  searchType: FramesSearchType,
) => {
  setLoadingAccounts(true);
  const { framesAccounts, error } = await framesService.getFramesAccounts(accountNum, searchType);

  if (error) {
    setFetchAccountsErrorMessage(error);
    return;
  }

  setAccounts(framesAccounts!);
  setLoadingAccounts(false);
};
